/**
 * IDs are drawn from Confluence to match "Item"
 * https://weathergroup.atlassian.net/wiki/spaces/WEX/pages/2329280567/My+Weather+-+Home
 * Internationalization JSON properties should also match these (refer to myWeatherPage.json)
 */
export const myWeatherPageTestIDs = {
  myWeatherPage: 'my_weather_page',
  alertCrawlWidget: 'my_weather_page_alert_crawl_widget',
  changeCityButton: 'my_weather_page_change_city_button',
  changeCityModalPlaceholder: 'my_weather_page_change_city_modal_placeholder',
  changeCityIcon: 'my_weather_page_change_city_icon',
  currentWeatherConditionsTile: 'my_weather_page_current_weather_conditions_tile',
  currentWeatherConditionsTileTemperature: 'my_weather_page_current_weather_conditions_tile_temperature',
  dailyForecastTile: 'my_weather_page_daily_forecast_tile',
  hourlyForecastTile: 'my_weather_page_hourly_forecast_tile',
  pipWidget: 'picture_in_picture_widget',
  liveVideoPlayerHeader: 'my_weather_page_live_video_player_header',
  liveVideoPlayerTile: 'my_weather_page_live_video_player_tile',
  liveMapHeader: 'my_weather_page_live_map_header',
  liveMapTile: 'my_weather_page_live_map_tile',
  locationHeader: 'my_weather_page_location_header',
  logoAndTimeWidget: 'my_weather_page_logo_and_time_widget',
};
